import { handleOnError, handleOnOtherError } from './error';
import { handleOnUnhandledrejection } from './unhandledrejection';

/**
 * 初始化异常捕获事件
 */
export const initErrorEventCatcher = () => {
	// 通用错误处理
	window.onerror = handleOnError;
	// Promise 未捕获错误处理
	window.addEventListener('unhandledrejection', handleOnUnhandledrejection);
	// 其他通用错误
	window.addEventListener('error', handleOnOtherError);
};
